<template>
  <v-container fluid id="home" class="home fill-height">

    <EContractContent
      v-if="isLeader"
    ></EContractContent>

    <v-row v-else class="text-center"> 
      <v-col>
        <br><br><br>
        <v-form
          ref="form"
          @submit.prevent="signInAsLeader"
        >
          <h3>Please enter leader's password to continue</h3>
          <br>                    
          <v-text-field
            v-model="password"

            label="Password"
            outlined
            dense
            :append-icon="show3 ? mdiEye : mdiEyeOff"
            :type="show3 ? 'text' : 'password'"
            @click:append="show3 = !show3"
          ></v-text-field>

          <v-btn :disabled="!formIsValid" color="primary" type="submit" >Sign In</v-btn>
          <br>
        </v-form>

        <v-overlay :value="overlay">
        <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
        > 
            <br>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            <h3 class="title ma-3">Signing In</h3>
            <br>
            
            <!--
            <v-btn
            icon
            @click="overlay = false"
            x-large
            
            >
            <v-icon>mdi-close</v-icon>
            Dismiss
            </v-btn>-->

        </v-card>
        </v-overlay>
        <v-overlay :value="overlayError">
        <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
        > 
            <br>
            <h3 class="title ma-3">Password Error !</h3><p class="sub-title">Please enter correct password.</p>
            
            <v-btn
            icon
            @click="overlayError = false"
            x-large
            
            >
            <v-icon>{{mdiClose}}</v-icon>
            Dismiss
            </v-btn>
        </v-card>
        </v-overlay>
        <v-overlay :value="overlayInfoError">
        <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
        > 
            <br>
            <h3 class="title ma-3">Invalid Input.</h3><p class="sub-title">Please fill up the form.</p>
            
            <v-btn
            icon
            @click="overlayInfoError = false"
            x-large
            
            >
            <v-icon>{{mdiClose}}</v-icon>
            Dismiss
            </v-btn>
        </v-card>
        </v-overlay>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
// @ is an alias to /src
import EContractContent from '@/components/Econtract.vue'
import {  mdiClose, mdiEye, mdiEyeOff } from '@mdi/js'

export default {
  components: {
    EContractContent
  },
  data () {
    return {
      mdiClose,
      mdiEye,
      mdiEyeOff,
      isLeader: '',
      overlay: false,
      overlayError: false,
      overlayInfoError: false,
      password: '',
      show3: false,
    }
  },

  computed: {
    formIsValid() {
      return this.password 
    }  
  },

  methods: {
    signInAsLeader() {
      if (this.password === 'leader') {
        this.overlay = true
        window.sessionStorage.setItem('isLeader', true)
        this.isLeader = true
        this.overlay = false
      } else {
        this.overlayError = true
      }
    },
  },

  mounted() {
    //console.log('e-contract mounted : isLeader ==> ' + window.sessionStorage.getItem('isLeader'));
    if (window.sessionStorage.getItem('isLeader') == 'true') {
      this.isLeader = true
    } else {
      this.isLeader = false
    }
  },

  destroyed() {
    //console.log('e-contract destroyed');
    //window.sessionStorage.setItem('isLeader', false)
  }
}
</script>